import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";

export async function checkAiSubscriptionStatus() {
    const response = await api.get(CompanyRoutes.AI.CHECK_STATUS);
    //const { data } = response.data;
    return response;
}


export async function getAiPlans(){
    const response = await api.get(CompanyRoutes.AI.PLANS);
    return response;
}

export async function subscribeToAiPlan(plan_id){
    const response = await api.post(CompanyRoutes.AI.SUBSCRIBE,{plan_id});
    return response;
}


export async function sendMetaCodeToBackend(metaCode){
    const cleanCode = typeof metaCode === 'object' && metaCode.code ? metaCode.code : metaCode;
    
    const response = await api.post(CompanyRoutes.AI.WHATSAPP_CALLBACK,{
        code: cleanCode
    });

    return response
}